import env from '@config/env';

const apiConfig = {
  baseURL: env.API_URL,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: false,
};

export default apiConfig;
